import AuthService from "./AuthService";

//const BASE_URL = "http://localhost:8081/api/bloodtype";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const BASE_URL = `${API_BASE_URL}/api/bloodtype`;
class BloodTypeService {
  getAllBloodTypes() {
    return fetch(BASE_URL, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader()
      }
    }).then(res => res.json());
  }

  getBloodTypeById(id) {
    return fetch(`${BASE_URL}/${id}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader()
      }
    }).then(res => res.json());
  }

  createBloodType(bloodType) {
    return fetch(BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader()
      },
      body: JSON.stringify(bloodType)
    }).then(res => res.json());
  }

  updateBloodType(id, bloodType) {
    return fetch(`${BASE_URL}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader()
      },
      body: JSON.stringify(bloodType)
    }).then(res => res.json());
  }

  deleteBloodType(id) {
    return fetch(`${BASE_URL}/${id}`, {
      method: "DELETE",
      headers: AuthService.getAuthHeader()
    }).then(res => res.json());
  }
}

export default new BloodTypeService();
